import request from "../utils/request.js";

function normalizeMultipartPayload(params) {
    if (params instanceof FormData) {
        return params;
    }

    const formData = new FormData();
    Object.keys(params || {}).forEach((key) => {
        const value = params[key];
        if (value !== undefined && value !== null) {
            formData.append(key, value);
        }
    });
    return formData;
}

export function getGenericResourceList(params = {}) {
    const queryString = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
    return request({
        url: `/genericResource/list?${queryString}`,
        method: "get"
    });
}

/** CMS 多行粘贴：一次按精确名批量查（大小写不敏感，服务端最多 30 个） */
export function getGenericResourceListByExactNames(data = {}) {
    return request({
        url: `/genericResource/listByExactNames`,
        method: "post",
        data,
    });
}


export function getGenericResourceById(params = {}) {
    const queryString = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
    return request({
        url: `/genericResource/getWallpaperById?${queryString}`,
        method: "get"
    });
}


// 上下线接口
export function onOrOff(params) {
    return request({
      url: `/genericResource/onOrOff`,
      method: "post",
      data: params
    });
}

export function deleteGenericResource(params) {
    return request({
      url: `/genericResource/deleteWallpaperById`,
      method: "post",
      data: params
    });
}

export function batchDeleteGenericResource(params) {
    return request({
      url: `/genericResource/deleteWallpaperByIds`,
      method: "post",
      data: params,
    });
}

/** 复制通用资源（新 key，默认下线） */
export function copyGenericResource(params) {
    return request({
      url: `/genericResource/copy`,
      method: "post",
      data: params,
    });
}

export function addGenericResource(params, config = {}) {
    return request({
    ...config,
      url: `/genericResource/addWallpaper`,
      method: "post",
    data: normalizeMultipartPayload(params)
    });
}

export function replaceGenericResourceSticker(params, config = {}) {
    return request({
      ...config,
      url: `/genericResource/replaceSticker`,
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: normalizeMultipartPayload(params),
    });
}

export function updateGenericResource(params, config = {}) {
    return request({
    ...config,
      url: `/genericResource/updateWallpaper`,
      method: "post",
    data: normalizeMultipartPayload(params)
    });
}

export function getGenericResourceDownloadZip(params = {}) {
    const queryString = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
    return request({
        url: `/genericResource/downloadZip?${queryString}`,
        method: "get",
        // 业务失败由页面展示一次真实 errMessage，避免拦截器再弹一层「无法解析…」造成双 toast
        resolveErrorDataOnBizError: true,
    });
}

export function listAllWallpaperType() {
    return request({
      url: `/genericResource/listAllWallpaperType`,
      method: "get"
    });
}

/** 换图和整包重认的待办。 */
export function listStickerAiTasks(resourceId) {
    return request({ url: `/genericResource/stickerAiTask?resourceId=${encodeURIComponent(resourceId)}`, method: "get" });
}

/** 整包和每一张上的词，带出身和是谁绑上的。 */
export function listStickerTags(resourceId) {
    return request({ url: `/genericResource/stickerTags?resourceId=${encodeURIComponent(resourceId)}`, method: "get" });
}

/** 失败后只补未完成的原图 emoji。 */
export function retryGenericResourceStickerInitialization(id) {
    return request({ url: `/genericResource/retryStickerInitialization?id=${encodeURIComponent(id)}`, method: "post" });
}

/** 换 zip 失败后放弃这次初始化，恢复换包前的上下线状态；新建的包后端会拒绝。 */
export function abandonGenericResourceStickerInitialization(id) {
    return request({ url: `/genericResource/abandonStickerInitialization?id=${encodeURIComponent(id)}`, method: "post" });
}
